import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyBk-sQsY-0KxPUeT03LFA10K_1e8SvFjnc',
  authDomain: 'cad-ai-3a829.firebaseapp.com',
  projectId: 'cad-ai-3a829',
  storageBucket: 'cad-ai-3a829.firebasestorage.app',
  messagingSenderId: '572273844536',
  appId: '1:572273844536:web:a9ee8cc133cf981c85a1cd',
  measurementId: 'G-F0T3DPXJ9X',
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const firestore = getFirestore(app);
export const storage = getStorage(app);

// Connect to emulators in development
if (import.meta.env.DEV && import.meta.env.VITE_USE_EMULATORS === 'true') {
  connectAuthEmulator(auth, 'http://localhost:9099');
  connectFirestoreEmulator(firestore, 'localhost', 8080);
  connectStorageEmulator(storage, 'localhost', 9199);
}

// Cloud Functions base URL
export const FUNCTIONS_URL = import.meta.env.DEV && import.meta.env.VITE_USE_EMULATORS === 'true'
  ? 'http://localhost:5001/cad-ai-3a829/us-central1'
  : 'https://us-central1-cad-ai-3a829.cloudfunctions.net';
